import React, {useRef, useEffect, useState} from 'react';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import {MediaPlayer, MediaProvider} from '@vidstack/react';
import {defaultLayoutIcons, DefaultVideoLayout} from '@vidstack/react/player/layouts/default';
import {Poster} from '@vidstack/react';

import '../../styles/video-player-styling/player.css';

const VideoPlayer = () => {
    const playerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);

    const handlePlay = () => {
        if (playerRef.current) {
            playerRef.current.play();
        }
    };

    useEffect(() => {
        const player = playerRef.current;

        const handlePlaying = () => {
            setIsPlaying(true);
            setHasStarted(true);
        };

        const handlePause = () => {
            setIsPlaying(false);
        };

        if (player) {
            player.addEventListener('playing', handlePlaying);
            player.addEventListener('pause', handlePause);

            return () => {
                player.removeEventListener('playing', handlePlaying);
                player.removeEventListener('pause', handlePause);
            };
        }
    }, []);

    return (
        <div>
          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <div
              style={{
                display:      "inline-flex",
                alignItems:   "center",
                gap:          "7px",
                background:   "rgba(22,163,74,0.08)",
                border:       "1px solid rgba(22,163,74,0.25)",
                borderRadius: "99px",
                padding:      "5px 14px",
                marginBottom: "16px",
              }}
            >
              <span
                style={{
                  width: "6px", height: "6px",
                  borderRadius: "50%",
                  background: "#16a34a",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize:      "0.8125rem",
                  fontWeight:    600,
                  color:         "#16a34a",
                  fontFamily:    "'DM Sans', system-ui, sans-serif",
                  letterSpacing: "0.01em",
                }}
              >
                IN GOD WE TRUST
              </span>
            </div>
            <h2
              style={{
                fontFamily:    "'DM Sans', system-ui, sans-serif",
                fontWeight:    800,
                fontSize:      "clamp(1.75rem, 4vw, 2.75rem)",
                color:         "#0f0f10",
                letterSpacing: "-0.03em",
                lineHeight:    1.15,
                margin:        0,
              }}
            >
              Watch how brands build economies.
            </h2>
          </div>
        <div className={`video-player ${isPlaying || hasStarted ? 'playing' : ''}`}>
            <MediaPlayer
                ref={playerRef}
                crossOrigin
                // playsInline TODO: Look at which is better for mobile
                title="Pabloo | Company Video"
                src="https://www.youtube.com/watch?v=mVTksfdKOzo"
            >
                <MediaProvider>
                    <Poster
                        className="vds-poster"
                        src="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/Pabloo%20Media%2Fvideo_thumbnail_lincoln.png?alt=media&token=b0240ee6-4735-434b-aa09-a35bcfb46470"
                        alt="Pabloo | Company Video Thumbnail"
                    />
                </MediaProvider>
                <DefaultVideoLayout icons={defaultLayoutIcons}/>
            </MediaPlayer>
            {!hasStarted && (
                <div className="central-play-button" onClick={handlePlay}>
                    <svg
                        fill="#ffffff"
                        width="55"
                        height="55"
                        viewBox="-4 -3 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMinYMin"
                        className="jam jam-play"
                    >
                        <path
                            d="M13.82 9.523a.976.976 0 0 0-.324-1.363L3.574 2.128a1.031 1.031 0 0 0-.535-.149c-.56 0-1.013.443-1.013.99V15.03c0 .185.053.366.153.523.296.464.92.606 1.395.317l9.922-6.031c.131-.08.243-.189.325-.317zm.746 1.997l-9.921 6.031c-1.425.867-3.3.44-4.186-.951A2.918 2.918 0 0 1 0 15.03V2.97C0 1.329 1.36 0 3.04 0c.567 0 1.123.155 1.605.448l9.921 6.032c1.425.866 1.862 2.696.975 4.088-.246.386-.58.712-.975.952z"/>
                    </svg>
                </div>
            )}
        </div>
        </div>
    );
};

export default VideoPlayer;
